// *****************************************************
// Define configurations for different environments
const configurations = {
  frontend: {
    api5: "https://api.isworld.online",
  },
  edupilot: {
    api5: "https://testapi.test.com.au/module5",
  },
};

// Set the environment mode
const environment = process.env.REACT_APP_ENVIRONMENT || "frontend";

// Select the configuration based on the environment
const base_url = configurations[environment];

export default base_url;
